import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-row-actions',
  template: `
  <button mat-icon-button *ngIf="actionTypes.includes('add')" [disabled]="disabledActions?.includes('add')"
   color="primary" matTooltip="Add" (click)="action('add')">
    <mat-icon>add</mat-icon>
  </button>
  <button mat-icon-button *ngIf="actionTypes.includes('view')" [disabled]="disabledActions?.includes('view')"
  color="primary" matTooltip="View" (click)="action('view')">
    <mat-icon>visibility</mat-icon>
  </button>
  <button mat-icon-button *ngIf="actionTypes.includes('edit')" [disabled]="disabledActions?.includes('edit')"
  color="primary" matTooltip="Edit" (click)="action('edit')">
    <mat-icon>edit</mat-icon>
  </button>
  <button mat-icon-button *ngIf="actionTypes.includes('delete')" [disabled]="disabledActions?.includes('delete')"
  color="warn" matTooltip="Delete" (click)="action('delete')">
    <mat-icon>delete</mat-icon>
  </button>
  <button mat-icon-button *ngIf="actionTypes.includes('stop')" [disabled]="disabledActions?.includes('stop')"
  color="warn" matTooltip="Stop" (click)="action('stop')">
    <mat-icon>block</mat-icon>
  </button>
  <button mat-icon-button *ngIf="actionTypes.includes('restart')" [disabled]="disabledActions?.includes('restart')"
  color="primary" matTooltip="Restart" (click)="action('restart')">
    <mat-icon>sync</mat-icon>
  </button>
  <button mat-icon-button *ngIf="actionTypes.includes('accept')" [disabled]="disabledActions?.includes('accept')"
  color="success" matTooltip="Accept" (click)="action('accept')">
    <mat-icon>check</mat-icon>
  </button>
  <button mat-icon-button *ngIf="actionTypes.includes('reject')" [disabled]="disabledActions?.includes('reject')"
  color="warn" matTooltip="Reject" (click)="action('reject')">
    <mat-icon>close</mat-icon>
  </button>

  <button mat-icon-button *ngIf="actionTypes.includes('influencer')" [disabled]="disabledActions?.includes('influencer')"
  color="primary" matTooltip="Influencers" (click)="action('influencer')">
    <mat-icon>record_voice_over</mat-icon>
  </button>
  `,
  styles: []
})
export class RowActionsComponent {

  @Input() actionTypes: string[];
  @Input() disabledActions: string[] = [];
  @Output() emitAction = new EventEmitter<string>();

  action(type: string) {
    this.emitAction.emit(type);
  }

  constructor() { }

}
